"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const organisation_service_1 = require("../services/organisation.service");
const bed_status_item_dto_1 = require("../dtos/bed-status-item-dto");
require("../dtos/bed-history-dto");
const dialog_1 = require("@angular/material/dialog");
const dnaR_action_modal_component_1 = require("../../common/components/dnaR-action-modal/dnaR-action-modal.component");
const i0 = require("@angular/core");
const i1 = require("../services/organisation.service");
const i2 = require("@angular/material/dialog");
const i3 = require("@angular/material/button");
const i4 = require("@angular/material/tooltip");
const i5 = require("@angular/material/icon");
const i6 = require("@angular/common");
const i7 = require("../../common/components/dnaR-datePicker/dnaR-datePicker.component");
const i8 = require("@angular/forms");
const i9 = require("@angular/material/form-field");
function EditBedStatusComponent_tbody_49_tr_2_mat_error_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error", 28);
    i0.ɵɵtext(1, "\n                                ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHtml", item_r4.currentError, i0.ɵɵsanitizeHtml);
} }
function EditBedStatusComponent_tbody_49_tr_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtext(1, "\n                            ");
    i0.ɵɵelementStart(2, "td");
    i0.ɵɵtext(3, "\n                                ");
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5, "\n                                    Out of service\n                                ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, "\n                            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, "\n                            ");
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵtext(9, "\n                                ");
    i0.ɵɵelementStart(10, "dnaR-date-picker", 22);
    i0.ɵɵlistener("ngModelChange", function EditBedStatusComponent_tbody_49_tr_2_Template_dnaR_date_picker_ngModelChange_10_listener($event) { i0.ɵɵrestoreView(_r9); const item_r4 = ctx.$implicit; return item_r4.startDate = $event; })("onComponentChange", function EditBedStatusComponent_tbody_49_tr_2_Template_dnaR_date_picker_onComponentChange_10_listener($event) { i0.ɵɵrestoreView(_r9); const item_r4 = ctx.$implicit; const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.onStartDateValueChanged($event, item_r4); });
    i0.ɵɵtext(11, "\n                                ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12, "\n                            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(13, "\n                            ");
    i0.ɵɵelementStart(14, "td");
    i0.ɵɵtext(15, "\n                                ");
    i0.ɵɵelementStart(16, "dnaR-date-picker", 23);
    i0.ɵɵlistener("ngModelChange", function EditBedStatusComponent_tbody_49_tr_2_Template_dnaR_date_picker_ngModelChange_16_listener($event) { i0.ɵɵrestoreView(_r9); const item_r4 = ctx.$implicit; return item_r4.endDate = $event; })("onComponentChange", function EditBedStatusComponent_tbody_49_tr_2_Template_dnaR_date_picker_onComponentChange_16_listener($event) { i0.ɵɵrestoreView(_r9); const item_r4 = ctx.$implicit; const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.onEndDateValueChanged($event, item_r4); });
    i0.ɵɵtext(17, "\n                                ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(18, "\n                                ");
    i0.ɵɵtemplate(19, EditBedStatusComponent_tbody_49_tr_2_mat_error_19_Template, 2, 1, "mat-error", 24);
    i0.ɵɵtext(20, "\n                            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(21, "\n                            ");
    i0.ɵɵelementStart(22, "td", 25);
    i0.ɵɵtext(23, "\n                                ");
    i0.ɵɵelementStart(24, "a", 26);
    i0.ɵɵlistener("click", function EditBedStatusComponent_tbody_49_tr_2_Template_a_click_24_listener() { i0.ɵɵrestoreView(_r9); const i_r5 = ctx.index; const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.removeItem(i_r5); });
    i0.ɵɵelement(25, "span", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(26, "\n                            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(27, "\n                        ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngModel", item_r4.startDate)("validate", ctx_r3.isDirty);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngModel", item_r4.endDate);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !item_r4.isValid);
    i0.ɵɵadvance(5);
    i0.ɵɵclassProp("disabled", ctx_r3.items.length === 1 ? true : null);
} }
function EditBedStatusComponent_tbody_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtext(1, "\n                        ");
    i0.ɵɵtemplate(2, EditBedStatusComponent_tbody_49_tr_2_Template, 28, 6, "tr", 21);
    i0.ɵɵtext(3, "\n                    ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
} }
function EditBedStatusComponent_div_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtext(1, "\n                    No bed status records.\n                ");
    i0.ɵɵelementEnd();
} }
function EditBedStatusComponent_span_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1, "Showing last 6 months");
    i0.ɵɵelementEnd();
} }
class EditBedStatusComponent {
    constructor(organisationService, dialog) {
        this.organisationService = organisationService;
        this.dialog = dialog;
        this.doneButtonPressed = new core_1.EventEmitter();
        this.deletedItems = [];
        this.bedHistory = [];
    }
    ngOnInit() {
        // Load the bed history, to ensure we don't overlap availabilities with occupation
    }
    ngOnChanges() {
        //bed status modal can be closed and reopened before saving 
        //room changes, so only load data from db if modal is being 
        //opened for the first time (i.e no data in items array yet)
        //or if a modal is being opened for a different bed than previously
        //opened:
        if (this.items.length === 0 || (this.bedId !== this.items[0].bedId)) {
            this.organisationService.getOutOfServiceBeds(this.bedId).then((result) => {
                this.items = result;
                //order items in reverse start date order:
                this.items.sort((a, b) => ((new Date(b.startDate).getTime()) - (new Date(a.startDate).getTime())));
                this.dateValidation(this.items);
            });
        }
        if (this.bedHistory.length === 0 || (this.bedId !== this.bedHistory[0].bedId)) {
            this.organisationService.getBedHistory(this.bedId).then((result) => {
                this.bedHistory = result;
                this.dateValidation(this.items);
            });
        }
        //order items in reverse start date order:
        this.items.sort((a, b) => ((new Date(b.startDate).getTime()) - (new Date(a.startDate).getTime())));
        this.dateValidation(this.items);
    }
    addItem() {
        if (this.items === undefined) {
            this.items = new Array(null, null, null);
        }
        else {
            this.items.unshift(new bed_status_item_dto_1.BedStatusItemDto(null, null, null, this.bedId));
        }
    }
    removeItem(index) {
        const dialogData = {
            title: "Delete status",
            text: "Are you sure you want to delete this status?",
            action: "Delete",
            actionButtonClass: "btn-primary",
            actionFunction: () => this.delete(index)
        };
        this.dialog.open(dnaR_action_modal_component_1.DnaRActionModalComponent, {
            panelClass: 'custom-dialog-container',
            disableClose: true,
            width: '456px',
            height: '226px',
            data: dialogData
        });
    }
    delete(index) {
        if (this.items.length > 0) {
            this.items[index].isDeleted = true;
            this.deletedItems.push(this.items[index]);
            this.items.splice(index, 1);
        }
        this.dateValidation(this.items);
    }
    cancel() {
        this.hide();
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            //add any items that were deleted to the list of current items 
            //and send event with this updated list so that edit room page
            //knows items to be saved and their current data:
            var updatedItems = this.items.concat(this.deletedItems);
            updatedItems.sort((a, b) => ((new Date(b.startDate).getTime()) - (new Date(a.startDate).getTime())));
            this.doneButtonPressed.emit(updatedItems);
            this.hide();
        });
    }
    addError(item, error) {
        this.isValid = false;
        item.isValid = false;
        if (item.currentError == "") {
            item.currentError = error;
        }
        else if (!item.currentError.includes(error)) {
            item.currentError += "<br />" + error;
        }
    }
    dateValidation(dateRows) {
        this.isValid = true;
        dateRows.forEach(dr => {
            dr.currentError = "";
            dr.isValid = true;
        });
        for (let i = 0; i < dateRows.length; i++) {
            let item = dateRows[i];
            if (!item.startDate && !item.endDate) {
                continue;
            }
            let itemStartDate = new Date(item.startDate);
            let itemEndDate = new Date(item.endDate);
            // If we have start and end, validate the end date is after start date
            if (item.startDate && item.endDate) {
                if (itemStartDate > itemEndDate) {
                    this.addError(item, "End date must be after start date");
                    continue;
                }
            }
            if (item.startDate == null && item.endDate != null) {
                this.isValid = false;
            }
            // Ensure there are no overlapping dates
            for (let j = i + 1; j < dateRows.length; j++) {
                let item2 = dateRows[j];
                let item2StartDate = null;
                if (item2.startDate != null) {
                    item2StartDate = new Date(item2.startDate);
                }
                let item2EndDate = null;
                if (item2.endDate != null) {
                    item2EndDate = new Date(item2.endDate);
                }
                if ((itemStartDate <= item2EndDate && itemEndDate >= item2StartDate)
                    || (item.endDate == null && itemStartDate <= item2EndDate)
                    || (item2.endDate == null && item2StartDate <= itemEndDate)
                    || (item2.endDate == null && item.endDate == null)) {
                    this.addError(item2, "Date conflicts with existing out of service record");
                    this.addError(item, "Date conflicts with existing out of service record");
                }
            }
            ;
            // Ensure that the range doesn't overlap an existing residency
            this.bedHistory.forEach(bh => {
                let bhStart = new Date(bh.startDateUtc);
                let bhEnd = new Date(bh.endDateUtc);
                if ((itemStartDate <= bhEnd && itemEndDate >= bhStart)
                    || (item.endDate == null && itemStartDate <= bhEnd)
                    || (bh.endDateUtc == null && bhStart <= itemEndDate)
                    || (bh.endDateUtc == null && item.endDate == null)) {
                    this.addError(item, "Date conflicts with resident occupied record");
                }
            });
        }
    }
    ;
    onStartDateValueChanged($event, item) {
        this.isDirty = true;
        if ($event.value != null) {
            // get the selected date      
            const selectedDate = new Date($event.value);
            // Convert the selected date to utc midnight
            var utcDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0, 0));
            // Store the UtcDate back on the item
            item.startDate = utcDate;
        }
        this.dateValidation(this.items);
    }
    onEndDateValueChanged($event, item) {
        this.isDirty = true;
        if ($event.value != null) {
            // get the selected date      
            const selectedDate = new Date($event.value);
            // Convert the selected date to utc midnight
            var utcDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0, 0));
            // Store the UtcDate back on the item
            item.endDate = utcDate;
        }
        this.dateValidation(this.items);
    }
}
exports.EditBedStatusComponent = EditBedStatusComponent;
EditBedStatusComponent.ɵfac = function EditBedStatusComponent_Factory(t) { return new (t || EditBedStatusComponent)(i0.ɵɵdirectiveInject(i1.OrganisationService), i0.ɵɵdirectiveInject(i2.MatDialog)); };
EditBedStatusComponent.ɵcmp = i0.ɵɵdefineComponent({ type: EditBedStatusComponent, selectors: [["edit-bed-status"]], inputs: { roomNumber: "roomNumber", bedNumber: "bedNumber", bedId: "bedId", items: "items", hide: "hide" }, outputs: { doneButtonPressed: "doneButtonPressed" }, features: [i0.ɵɵNgOnChangesFeature], decls: 79, vars: 6, consts: [[1, "modal-header", "modal-header-action", "bed-status-dialog"], [1, "modal-title", "modal-title-action", "bed-status-modal-header"], ["mat-icon-button", "", "type", "button", "matTooltip", "Cancel", "matTooltipClass", "mat-tooltip", "aria-label", "close dialog", 1, "modal-header", "close-modal", 3, "click"], [1, "icon", "icon-close-fill", "close-modal-icon"], [1, "bed-status-body"], [1, "room-details"], [1, "room-number"], [1, "bed-number"], [1, "col-xs-12", "bed-status-table"], [1, "dna-r"], [1, "table"], [1, "required"], [4, "ngIf"], ["class", "no-bed-status-records", 4, "ngIf"], [1, "col-xs-12", "noSidePadding"], ["class", "col-xs-9 noSidePadding", 4, "ngIf"], [1, "col-xs-3", "btn", "addNewItemButton", "pull-right", 3, "click"], [1, "icon", "icon-primary-t2", "icon-add-circle-fill"], [1, "modal-footer", "footer-bed-status"], ["type", "button", 1, "btn", "btn-warning", "btn-lg", 3, "click"], ["type", "button", 1, "btn", "btn-primary", "btn-lg", "pull-right", 3, "disabled", "click"], [4, "ngFor", "ngForOf"], ["name", "startDate", "ngDefaultControl", "", "required", "true", "requiredError", "Start date required", 3, "ngModel", "validate", "ngModelChange", "onComponentChange"], ["name", "endDate", "required", "false", 3, "ngModel", "ngModelChange", "onComponentChange"], [3, "innerHtml", 4, "ngIf"], [1, "col-xs-1"], ["matTooltip", "Delete", "title", "Delete", 1, "deleteLink", 3, "click"], [1, "icon", "icon-delete-fill", "pointer-cursor"], [3, "innerHtml"], [1, "no-bed-status-records"], [1, "col-xs-9", "noSidePadding"]], template: function EditBedStatusComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1, "\n    ");
        i0.ɵɵelementStart(2, "h3", 1);
        i0.ɵɵtext(3, "Bed status");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(4, "\n    ");
        i0.ɵɵelementStart(5, "button", 2);
        i0.ɵɵlistener("click", function EditBedStatusComponent_Template_button_click_5_listener() { return ctx.cancel(); });
        i0.ɵɵtext(6, "\n            ");
        i0.ɵɵelement(7, "mat-icon", 3);
        i0.ɵɵtext(8, "\n    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(9, "\n");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(10, "\n");
        i0.ɵɵelementStart(11, "div");
        i0.ɵɵtext(12, "\n    ");
        i0.ɵɵelementStart(13, "div", 4);
        i0.ɵɵtext(14, "\n        ");
        i0.ɵɵelementStart(15, "div", 5);
        i0.ɵɵtext(16, "\n            ");
        i0.ɵɵelementStart(17, "div", 6);
        i0.ɵɵtext(18);
        i0.ɵɵelementEnd();
        i0.ɵɵtext(19, "\n            ");
        i0.ɵɵelementStart(20, "div", 7);
        i0.ɵɵtext(21);
        i0.ɵɵelementEnd();
        i0.ɵɵtext(22, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(23, "\n        ");
        i0.ɵɵelementStart(24, "div", 8);
        i0.ɵɵtext(25, "\n            ");
        i0.ɵɵelementStart(26, "div", 9);
        i0.ɵɵtext(27, "\n                ");
        i0.ɵɵelementStart(28, "table", 10);
        i0.ɵɵtext(29, "\n                    ");
        i0.ɵɵelementStart(30, "thead");
        i0.ɵɵtext(31, "\n                        ");
        i0.ɵɵelementStart(32, "tr");
        i0.ɵɵtext(33, "\n                            ");
        i0.ɵɵelementStart(34, "th");
        i0.ɵɵtext(35, "Bed status");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(36, "\n                            ");
        i0.ɵɵelementStart(37, "th");
        i0.ɵɵelementStart(38, "span", 11);
        i0.ɵɵtext(39, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(40, " Start date");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(41, "\n                            ");
        i0.ɵɵelementStart(42, "th");
        i0.ɵɵtext(43, "End date");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(44, "\n                            ");
        i0.ɵɵelement(45, "th");
        i0.ɵɵtext(46, "\n                        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(47, "\n                    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(48, "\n                    ");
        i0.ɵɵtemplate(49, EditBedStatusComponent_tbody_49_Template, 4, 1, "tbody", 12);
        i0.ɵɵtext(50, "\n                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(51, "\n                ");
        i0.ɵɵtemplate(52, EditBedStatusComponent_div_52_Template, 2, 0, "div", 13);
        i0.ɵɵtext(53, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(54, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(55, "\n        ");
        i0.ɵɵelementStart(56, "div", 14);
        i0.ɵɵtext(57, "\n            ");
        i0.ɵɵtemplate(58, EditBedStatusComponent_span_58_Template, 2, 0, "span", 15);
        i0.ɵɵtext(59, "\n            ");
        i0.ɵɵelementStart(60, "button", 16);
        i0.ɵɵlistener("click", function EditBedStatusComponent_Template_button_click_60_listener() { return ctx.addItem(); });
        i0.ɵɵtext(61, "\n                ");
        i0.ɵɵelement(62, "span", 17);
        i0.ɵɵtext(63, "\n                ");
        i0.ɵɵelementStart(64, "span");
        i0.ɵɵtext(65, "New status");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(66, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(67, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(68, "\n    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(69, "\n    ");
        i0.ɵɵelementStart(70, "div", 18);
        i0.ɵɵtext(71, "\n        ");
        i0.ɵɵelementStart(72, "button", 19);
        i0.ɵɵlistener("click", function EditBedStatusComponent_Template_button_click_72_listener() { return ctx.cancel(); });
        i0.ɵɵtext(73, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(74, "\n        ");
        i0.ɵɵelementStart(75, "button", 20);
        i0.ɵɵlistener("click", function EditBedStatusComponent_Template_button_click_75_listener() { return ctx.submit(); });
        i0.ɵɵtext(76, "Done");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(77, "\n    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(78, "\n");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(18);
        i0.ɵɵtextInterpolate1("\n                Room ", ctx.roomNumber, "\n            ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("\n                Bed ", ctx.bedNumber, "\n            ");
        i0.ɵɵadvance(28);
        i0.ɵɵproperty("ngIf", ctx.items && ctx.items.length > 0);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.items || ctx.items.length === 0);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.items && ctx.items.length > 0);
        i0.ɵɵadvance(17);
        i0.ɵɵproperty("disabled", !ctx.isValid);
    } }, directives: [i3.MatButton, i4.MatTooltip, i5.MatIcon, i6.NgIf, i6.NgForOf, i7.DnaRDatePicker, i8.DefaultValueAccessor, i8.RequiredValidator, i8.NgControlStatus, i8.NgModel, i9.MatError], styles: [".bed-status-dialog[_ngcontent-%COMP%] {\n  width: 668px;\n  align-items: flex-start;\n  padding: 10px 10px 10px 25px !important;\n}\n.bed-status-dialog[_ngcontent-%COMP%]   .bed-status-modal-header[_ngcontent-%COMP%] {\n  position: static;\n  width: 456px;\n  float: left;\n  \n  font-family: Source Sans Pro;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 150%;\n  \n  letter-spacing: 0.03px;\n  padding-top: 5px;\n}\n   .mat-tooltip {\n  font-weight: 400;\n  font-size: 14px;\n  color: #000000 !important;\n  line-height: 14px;\n  height: 26px;\n  background: #ffffff;\n  border: 1px solid #595959;\n  border-radius: 4px;\n  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.14));\n  padding-bottom: 0px !important;\n  font-family: 'Source Sans Pro' !important;\n}\n.bed-status-body[_ngcontent-%COMP%] {\n  background-color: #F5F5F5;\n  display: flex;\n  width: 668px;\n  padding: 24px 32px 54px 32px;\n  align-items: flex-end;\n  align-content: flex-end;\n  gap: 23px 0px;\n  flex-wrap: wrap;\n}\n.bed-status-body[_ngcontent-%COMP%]   .room-details[_ngcontent-%COMP%]   .room-number[_ngcontent-%COMP%] {\n  font-family: Source Sans Pro;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 150%;\n  \n  letter-spacing: 0.03px;\n  height: 30px;\n  width: 100%;\n}\n.bed-status-body[_ngcontent-%COMP%]   .room-details[_ngcontent-%COMP%]   .bed-number[_ngcontent-%COMP%] {\n  font-family: Source Sans Pro;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  \n  color: #595959;\n}\n.bed-status-table[_ngcontent-%COMP%] {\n  background-color: #ffffff;\n  padding: 0;\n}\n.required[_ngcontent-%COMP%] {\n  color: red;\n}\n.addNewItemButton[_ngcontent-%COMP%] {\n  background-color: #F5F5F5;\n  color: #008381;\n  display: flex;\n  padding: 1px 3px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 2px;\n}\n.addNewItemButton[_ngcontent-%COMP%]:hover {\n  Color: #025450;\n  text-decoration: underline;\n}\n.modal-footer[_ngcontent-%COMP%] {\n  background-color: #ffffff;\n  border: 1px solid #D2D2D2;\n  padding-left: 30px;\n  padding-right: 30px;\n}\n.modal-footer.footer-bed-status[_ngcontent-%COMP%] {\n  display: flex;\n  width: 668px;\n  height: 70px;\n  padding: 15px 10px;\n  justify-content: flex-end;\n  align-items: flex-end;\n  gap: 10px;\n}\n.noSidePadding[_ngcontent-%COMP%] {\n  padding-right: 0;\n  padding-left: 0;\n}\n.no-bed-status-records[_ngcontent-%COMP%] {\n  width: 604px;\n  padding: 8px 16px !important;\n  align-items: center;\n  gap: 8px;\n  border-top: 1px solid var(--neutrals-n-6-divider, #D2D2D2);\n  background: var(--neutrals-white-secondary-button, #FFF);\n}\n.modal-header.close-modal[_ngcontent-%COMP%] {\n  padding: 0px !important;\n  top: -5px;\n  background-color: #ffffff;\n  float: right;\n  width: 40px !important;\n  height: 40px !important;\n  border-radius: 50%;\n}\n.modal-header.close-modal[_ngcontent-%COMP%]:hover, .modal-header.close-modal[_ngcontent-%COMP%]:focus {\n  background-color: #EBF5F5;\n}\n.pointer-cursor[_ngcontent-%COMP%] {\n  cursor: pointer;\n}\nmat-error[_ngcontent-%COMP%] {\n  color: #C53535;\n  float: left;\n  font-size: 12px;\n  padding-bottom: 5px;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(EditBedStatusComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'edit-bed-status',
                templateUrl: './edit-bed-status.component.html',
                styleUrls: ['./edit-bed-status.component.less'],
                preserveWhitespaces: true
            }]
    }], function () { return [{ type: i1.OrganisationService }, { type: i2.MatDialog }]; }, { roomNumber: [{
            type: core_1.Input
        }], bedNumber: [{
            type: core_1.Input
        }], bedId: [{
            type: core_1.Input
        }], items: [{
            type: core_1.Input
        }], hide: [{
            type: core_1.Input
        }], doneButtonPressed: [{
            type: core_1.Output
        }] }); })();
